import React from 'react'

import { AiOutlineUser } from 'react-icons/ai'

import { AdminContext } from 'contexts/AdminContext'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import MenuItem from './MenuItem'

import MenuConfig from './../MenuConfig'

// Transacciones que se muestran automáticamente para usuarios con ciertos flags
// aunque su rol no las tenga asignadas explícitamente.
const TRANSACCIONES_POR_FLAG = {
  flagGerencia: [
    CodigosTransaccionesConstant.ORDENESCOMPRAS_LISTA,
    CodigosTransaccionesConstant.ORDENESCOMPRAS_APROBACION_LISTA
  ]
}

const AppSidebar = () => {
  const __adminContext = React.useContext(AdminContext)

  const menuConfigValido = React.useMemo(() => {
    const config = __adminContext.valoresConfiguracionUsuario || {}
    const transaccionesUsuario = new Set(__adminContext.transacciones || [])
    Object.keys(TRANSACCIONES_POR_FLAG).forEach(flag => {
      if (config[flag]) {
        TRANSACCIONES_POR_FLAG[flag].forEach(t => transaccionesUsuario.add(t))
      }
    })

    const tienePermiso = transaccion => transaccionesUsuario.has(transaccion)

    const leerSubMenu = __subMenu => {
      let tempSalida = []

      for (let i = 0; i < __subMenu.length; i++) {
        const subMen = __subMenu[i]

        if (!!subMen.submenu) {
          const resultadoNAvegacioon = leerSubMenu(subMen.submenu)
          if (resultadoNAvegacioon && resultadoNAvegacioon.length > 0) {
            tempSalida.push({
              ...subMen,
              submenu: resultadoNAvegacioon
            })
          }
        } else {
          if (tienePermiso(subMen.transaccion)) {
            tempSalida.push(subMen)
          }
        }
      }

      return tempSalida
    }

    const leerArray = __array => {
      const salida = []

      for (let i = 0; i < __array.length; i++) {
        const element = __array[i]

        if (element.page && tienePermiso(element.transaccion)) {
          salida.push(element)
        } else if (!!element.submenu) {
          const salidaSubMenu = leerSubMenu(element.submenu)
          if (salidaSubMenu && salidaSubMenu.length > 0) {
            salida.push({
              ...element,
              submenu: salidaSubMenu
            })
          }
        }
      }

      return salida
    }

    const nuevosItems = leerArray(MenuConfig)

    return nuevosItems || []
  }, [__adminContext.transacciones, __adminContext.valoresConfiguracionUsuario])

  const menuHtml = React.useMemo(() => {
    const construirRoot = __array => {
      const salida = []

      for (let i = 0; i < __array.length; i++) {
        const element = __array[i]

        if (!element.submenu || element.submenu.length === 0) {
          salida.push(<MenuItem name={element.title} page={element.page} />)
        } else {
          salida.push(<MenuItem name={element.title} subMenuInfo={element.submenu} />)
        }
      }

      return salida
    }

    const menuConstruido = construirRoot(menuConfigValido)

    return menuConstruido || []
  }, [menuConfigValido])

  return (
    <div className='app-sidebar'>
      <div className='sidebar-user'>
        <div className='user-body'>
          <AiOutlineUser />
        </div>
        <div className='user-info'>
          <a href='#!'>
            <span className='info-name'>{__adminContext.usuario}</span>
            {/* <br />
            <span className='info-role'>Administrador</span> */}
          </a>
        </div>
      </div>
      <ul className='sidebar-menu'>{menuHtml}</ul>
    </div>
  )
}

export default React.memo(AppSidebar)
